import axios from 'axios'
import {initializeApp} from 'firebase/app'
import {getMessaging, getToken, onMessage} from 'firebase/messaging'
import {toast} from 'react-toastify'
import {API_ENDPOINTS} from './app/constants/apiConstants'

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
}

// Initialize Firebase

const app = initializeApp(firebaseConfig)
// Initialize Firebase Cloud Messaging
let messaging: ReturnType<typeof getMessaging> | null = null

// Register the service worker for Firebase Cloud Messaging
if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/firebase-messaging-sw.js')
    .then(async (registration) => {
      if (registration.active) {
        registration.active.postMessage({
          type: 'INIT_FIREBASE',
          config: firebaseConfig,
        })

        messaging = getMessaging(app)

        onMessage(messaging, (payload) => {
          toast.warn(`${payload.notification?.title}: ${payload.notification?.body}`)
        })
      }
    })
    .catch((error) => {
      console.error('Service Worker registration failed:', error)
    })
}

// ✅ Request permission and get the FCM token
export const requestNotificationPermission = async (): Promise<string | null> => {
  try {
    const permission = await Notification.requestPermission()
    if (permission === 'granted') {
      if (!messaging) return null
      const token = await getToken(messaging, {
        vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
      })
      if (token) {
        // console.log('FCM Token:', token)
        return token
      }
    }
    return null
  } catch (error) {
    // Optionally handle errors
    return null
  }
}

// ✅ Handle foreground messages
if (messaging) onMessage(messaging, (payload) => {})

// Handle messages when the app is in the foreground
export const onMessageListener = (): Promise<unknown> =>
  new Promise((resolve) => {
    if (messaging)
      onMessage(messaging, (payload) => {
        toast.warn(`${(payload as any).notification.title}: ${(payload as any).notification.body} `)
        resolve(payload)
      })
  })

export const createFcmToken = async (fcmToken: string, authToken?: string, userId?: number | string) => {
  try {
    const headers: any = {
      'Content-Type': 'application/json',
    }
    
    // Add authorization headers if token is provided
    // Support both Laravel (Bearer) and Node.js (auth-token) authentication
    if (authToken) {
      headers['Authorization'] = `Bearer ${authToken}`  // For Laravel backend
      headers['auth-token'] = authToken                 // For Node.js backend
    }

    const response = await axios.post(API_ENDPOINTS.FCM_TOKEN(userId), 
      { fcm_token: fcmToken }, 
      { headers }
    )

    if (response.data?.status === 'Success') {
      return response.data
    } else {
      return null
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {
    } else {
    }
    return null
  }
}

// New function to handle FCM token creation after login
export const setupFcmTokenAfterLogin = async (authToken: string, userId: number | string) => {
  try {
    const fcmToken = await requestNotificationPermission()
    if (fcmToken) {
      await createFcmToken(fcmToken, authToken, userId)
    }
  } catch (error) {
    console.error('Error setting up FCM token after login:', error)
  }
}
